package com.klantenstop.web.utils

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.isExporting

object SiteGlobals {
    val adsenseClientId: String by lazy {
        AppGlobals["ADSENSE_CLIENT_ID"]?.takeIf { it.isNotBlank() } ?: ""
    }
    val adsenseHomeSlotId: String by lazy {
        AppGlobals["ADSENSE_HOME_SLOT_ID"]?.takeIf { it.isNotBlank() } ?: ""
    }
    val adsenseSearchSlotId: String by lazy {
        AppGlobals["ADSENSE_SEARCH_SLOT_ID"]?.takeIf { it.isNotBlank() } ?: ""
    }

    val postHogApiKey: String by lazy {
        AppGlobals["POSTHOG_API_KEY"]?.takeIf { it.isNotBlank() } ?: ""
    }
    val postHogHost: String by lazy {
        AppGlobals["POSTHOG_HOST"] ?: "https://eu.i.posthog.com"
    }
    val baseUrl: String by lazy {
        AppGlobals["BASE_URL"] ?: ""
    }

    // <editor-fold desc="environment">

    // Lazy-initialized AppGlobals value (only accessed when needed, not during tests if override is set)
    // 1 of development, staging or production. Defaults to development if not set.
    private val _appEnvironment: String by lazy {
        AppGlobals["ENVIRONMENT"] ?: "development"
    }

    // Internal test override — only used in tests. Reset to null to restore AppGlobals behaviour.
    internal var _testEnvironmentOverride: String? = null

    val environment: String
        get() = _testEnvironmentOverride ?: _appEnvironment
    // </editor-fold>

    val isExporting get() = AppGlobals.isExporting
}
